import TwitterIcon from '@/images/layout/footer-social-media-twitter.png';
import YoutubeIcon from '@/images/layout/footer-social-media-youtube.png';
import TikTokIcon from '@/images/layout/footer-social-media-tk.png';
import LinkedinIcon from '@/images/layout/footer-social-media-linkedIn.png';
import InstagramIcon from '@/images/layout/footer-social-media-instagram.png';
import FacebookIcon from '@/images/layout/footer-social-media-facebook.png';

export const SOCIAL_MEDIA_INFO = [
  {
    link: 'https://twitter.com/JapanNotta',
    icon: {
      src: TwitterIcon,
      alt: 'Twitter',
    },
  },
  {
    link: 'https://www.youtube.com/channel/UCLcc5s8xxJGMoxgPBtYLmKw/featured',
    icon: {
      src: YoutubeIcon,
      alt: 'Youtube',
    },
  },
  {
    link: 'https://www.tiktok.com/@notta_japan',
    icon: {
      src: TikTokIcon,
      alt: 'TikTok',
    },
  },
  {
    link: 'https://www.linkedin.com/company/96079897',
    icon: {
      src: LinkedinIcon,
      alt: 'Linkedin',
    },
  },
  {
    link: 'https://www.instagram.com/notta_japan/',
    icon: {
      src: InstagramIcon,
      alt: 'Instagram',
    },
  },
  {
    link: 'https://www.facebook.com/Notta%E3%83%8E%E3%83%83%E3%82%BF-102040918784359/?ref=pages_you_manage',
    icon: {
      src: FacebookIcon,
      alt: 'Facebook',
    },
  },
];
